import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import * as Icons from 'lucide-react';
import { ADMIN_NAV, COMPANY } from '@/lib/data';
import { cn } from '@/lib/utils';

export const Sidebar = ({ collapsed, onToggle }) => (
    <aside data-testid="admin-sidebar" className={cn('hidden md:flex shrink-0 flex-col bg-white border-r border-border transition-all duration-300', collapsed ? 'w-16' : 'w-64')}>
        <div className={cn('flex items-center gap-2 px-4 h-20 border-b border-border', collapsed && 'justify-center px-0')}>
            <img src={COMPANY.logo} alt={COMPANY.name} className="h-14 w-14 object-contain" />
        </div>
        <nav className="flex-1 overflow-y-auto py-3 px-2">
            <ul className="space-y-0.5">
                {ADMIN_NAV.map((item) => {
                    const Icon = Icons[item.icon] || Icons.Circle;
                    return (
                        <li key={item.to}>
                            <NavLink
                                to={item.to}
                                data-testid={`admin-nav-${item.label.toLowerCase().replace(/[^a-z]/g, '-')}`}
                                className={({ isActive }) => cn(
                                    'flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors',
                                    isActive
                                        ? 'bg-[hsl(var(--kche-cyan))]/10 text-[hsl(var(--kche-cyan))]'
                                        : 'text-foreground/80 hover:bg-secondary'
                                )}
                            >
                                <Icon className="size-4 shrink-0" />
                                {!collapsed && <span>{item.label}</span>}
                            </NavLink>
                        </li>
                    );
                })}
            </ul>
        </nav>
        <button type="button" onClick={onToggle} className="m-2 inline-flex items-center justify-center rounded-lg border border-border p-2 text-foreground/70 hover:bg-secondary" aria-label="Colapsar menú">
            {collapsed ? <Icons.ChevronRight className="size-4" /> : <Icons.ChevronLeft className="size-4" />}
        </button>
    </aside>
);

export default Sidebar;
